import { Button } from '@/components/ui/button';
import { Link, router } from '@inertiajs/react';
import { Mail } from 'lucide-react';
import { useState } from 'react';

interface Props {
  email_address: string;
}

export default function VerificationSent({ email_address }: Props) {
  const [isResending, setIsResending] = useState(false);

  const handleResend = () => {
    setIsResending(true);
    router.post(
      '/email_verification',
      {
        email_address: email_address,
      },
      {
        onFinish: () => setIsResending(false),
      }
    );
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center space-y-4 w-full md:max-w-lg px-4">
        <div className="flex justify-center">
          <Mail className="w-12 h-12 text-primary" />
        </div>

        <h1 className="text-2xl font-semibold">Check your email</h1>

        <p>
          We sent a verification link to&nbsp;
          <span className="text-primary font-bold">{email_address}</span>
        </p>
        <Link
          href="/session/new"
          className="text-sm underline underline-offset-4"
        >
          Back to login
        </Link>

        <div className="pt-20">
          <p className="text-sm text-muted-foreground">
            Didn't receive the email?
          </p>

          <Button
            variant="link"
            onClick={handleResend}
            disabled={isResending}
            className="w-full"
          >
            {isResending ? 'Sending...' : 'Click to resend'}
          </Button>
        </div>
      </div>
    </div>
  );
}
